/* Updated: 2026-09-18 23:10 BST — contact picker instructions use assets.go.travel only */

(function () {
  var PRODUCT_CATEGORY = 'product';
  var SEARCH_LIMIT = 8;
  var COLLECTION_LIMIT = 50;
  var searchTimer = null;

  function debounce(fn, wait) {
    if (window.theme && window.theme.utils && typeof window.theme.utils.debounce === 'function') {
      return window.theme.utils.debounce(fn, wait);
    }
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function routes() {
    return (window.theme && window.theme.routes) || {
      shop_url: window.location.origin,
      root_url: '/'
    };
  }

  function apiRoot(pickerEl) {
    var custom = pickerEl && pickerEl.getAttribute('data-api-root');
    if (custom) {
      if (custom.charAt(0) !== '/') custom = '/' + custom;
      if (custom.length > 1 && custom.charAt(custom.length - 1) !== '/') custom += '/';
      return custom;
    }
    var root = routes().root_url || '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.length > 1 && root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function apiUrl(pickerEl, pathAndQuery) {
    var shop = (routes().shop_url || window.location.origin).replace(/\/$/, '');
    var root = apiRoot(pickerEl);
    var path = String(pathAndQuery || '');
    if (path.charAt(0) === '/') path = path.slice(1);
    return shop + root + path;
  }

  function productImage(product) {
    if (!product) return '';
    if (typeof product.image === 'string' && product.image) return product.image;
    if (product.image && product.image.url) return product.image.url;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.images && product.images.length && product.images[0].src) return product.images[0].src;
    return '';
  }

  function readCategoryTree(pickerId) {
    var node = document.querySelector('[data-gohub-category-tree="' + pickerId + '"]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (e) {
      console.warn('[gohub-product-picker] Invalid category tree JSON');
      return [];
    }
  }

  function productRefFromSku(sku) {
    if (!sku) return '';
    return String(sku).split('.')[0].trim();
  }

  function parseInstructionsMeta(raw) {
    if (!raw) return null;
    var text = String(raw).trim();
    try {
      var data = JSON.parse(text);
      if (!data || typeof data !== 'object' || !('has_instructions' in data)) return null;
      return {
        has_instructions: data.has_instructions === true,
        instructions_ref: data.instructions_ref ? String(data.instructions_ref).trim() : ''
      };
    } catch (e) {
      return null;
    }
  }

  function isAssetsMirrorUrl(url) {
    try {
      var host = new URL(url).hostname.replace(/^www\./, '');
      return host === 'assets.go.travel' || host.endsWith('.assets.go.travel');
    } catch (e) {
      return String(url || '').indexOf('assets.go.travel') !== -1;
    }
  }

  function hubInstructionsApiBase(pickerEl) {
    return (pickerEl && pickerEl.getAttribute('data-instructions-api-base') || 'https://hub.go.travel').replace(/\/$/, '');
  }

  function fetchAssetsInstructionUrl(pickerEl, ref) {
    if (!ref) return Promise.resolve('');
    var url = hubInstructionsApiBase(pickerEl) + '/api/public/product-instructions/' + encodeURIComponent(ref);
    return fetch(url, { credentials: 'omit', mode: 'cors' })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || !data || data.show !== true) return '';
        var href = data.mirrorUrl || data.href || '';
        return isAssetsMirrorUrl(href) ? String(href) : '';
      })
      .catch(function () {
        return '';
      });
  }

  function ProductPicker(pickerEl) {
    this.picker = pickerEl;
    this.pickerId = pickerEl.getAttribute('data-picker-id') || '';
    this.root = pickerEl.closest('[data-gohub-contact-form]');
    this.categorySelect = this.root ? this.root.querySelector('[data-gohub-field="category"]') : null;
    this.selected = null;
    this.categoryTree = readCategoryTree(this.pickerId);
    this.pageProductMode = pickerEl.getAttribute('data-gohub-picker-page-product') === 'true'
      || (this.root && this.root.getAttribute('data-gohub-page-product') === 'true');
    this.userClearedPageProduct = false;
    this.bind();
  }

  ProductPicker.prototype.bind = function () {
    var self = this;

    if (!this.root || !this.categorySelect) return;

    this.categorySelect.addEventListener('change', function () {
      self.onCategoryChange();
    });

    this.picker.querySelectorAll('[data-gohub-picker-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setMode(btn.getAttribute('data-gohub-picker-mode'));
      });
    });

    var searchInput = this.picker.querySelector('[data-gohub-picker-search]');
    if (searchInput) {
      searchInput.addEventListener('input', debounce(function () {
        self.runSearch(searchInput.value.trim());
      }, 280));
    }

    var categorySelect = this.picker.querySelector('[data-gohub-picker-category]');
    if (categorySelect) {
      categorySelect.addEventListener('change', function () {
        self.onMasterCategoryChange(categorySelect.value);
      });
    }

    var subcategorySelect = this.picker.querySelector('[data-gohub-picker-subcategory]');
    if (subcategorySelect) {
      subcategorySelect.addEventListener('change', function () {
        self.onSubcategoryChange();
      });
    }

    var clearBtn = this.picker.querySelector('[data-gohub-picker-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        self.clearSelection();
      });
    }

    var form = this.root.closest('form');
    if (form) {
      form.addEventListener('submit', function (ev) {
        if (!self.validate()) {
          ev.preventDefault();
          ev.stopPropagation();
        }
      }, true);
    }

    this.populateMasterCategories();
    this.onCategoryChange();
    if (this.pageProductMode && this.categorySelect && this.categorySelect.value === PRODUCT_CATEGORY) {
      this.prefillFromPageProduct();
    }
  };

  ProductPicker.prototype.prefillFromPageProduct = function () {
    if (!this.pageProductMode || !this.root || this.userClearedPageProduct) return;
    var handle = this.root.getAttribute('data-gohub-product-handle') || '';
    if (!handle) return;

    this.selectProduct({
      id: this.root.getAttribute('data-gohub-product-id') || '',
      handle: handle,
      title: this.root.getAttribute('data-gohub-product-title') || '',
      image: this.root.getAttribute('data-gohub-product-image') || '',
      variant_sku: this.root.getAttribute('data-gohub-variant-sku') || '',
      variant_id: this.root.getAttribute('data-gohub-variant-id') || ''
    }, true);
  };

  ProductPicker.prototype.onCategoryChange = function () {
    var isProduct = this.categorySelect && this.categorySelect.value === PRODUCT_CATEGORY;
    this.picker.hidden = !isProduct;

    var headingEl = this.picker.querySelector('[data-gohub-picker-heading]');
    if (headingEl) {
      if (isProduct && this.pageProductMode) {
        headingEl.textContent = this.picker.getAttribute('data-page-product-heading')
          || 'This product';
      } else if (isProduct) {
        headingEl.textContent = headingEl.getAttribute('data-default-heading')
          || headingEl.textContent;
      }
    }

    if (isProduct) {
      if (this.pageProductMode && !this.userClearedPageProduct && !this.selected) {
        this.prefillFromPageProduct();
      } else if (!this.selected) {
        this.syncRootAttributes(null);
      }
    } else {
      this.clearSelection(false);
      this.setError(false);
    }
  };

  ProductPicker.prototype.setMode = function (mode) {
    this.picker.querySelectorAll('[data-gohub-picker-mode]').forEach(function (btn) {
      var active = btn.getAttribute('data-gohub-picker-mode') === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.picker.querySelectorAll('[data-gohub-picker-view]').forEach(function (view) {
      view.hidden = view.getAttribute('data-gohub-picker-view') !== mode;
    });
  };

  ProductPicker.prototype.populateMasterCategories = function () {
    var select = this.picker.querySelector('[data-gohub-picker-category]');
    if (!select) return;

    var placeholder = select.querySelector('option');
    select.innerHTML = '';
    if (placeholder) select.appendChild(placeholder);

    this.categoryTree.forEach(function (item) {
      var option = document.createElement('option');
      option.value = item.handle || ('group:' + item.title);
      option.textContent = item.title;
      option.dataset.groupTitle = item.title;
      select.appendChild(option);
    });
  };

  ProductPicker.prototype.findCategory = function (value) {
    for (var i = 0; i < this.categoryTree.length; i++) {
      var item = this.categoryTree[i];
      if ((item.handle && item.handle === value) || ('group:' + item.title) === value) {
        return item;
      }
    }
    return null;
  };

  ProductPicker.prototype.onMasterCategoryChange = function (value) {
    var subWrap = this.picker.querySelector('[data-gohub-picker-subcategory-wrap]');
    var subSelect = this.picker.querySelector('[data-gohub-picker-subcategory]');
    var grid = this.picker.querySelector('[data-gohub-picker-grid]');
    var gridLabel = this.picker.querySelector('[data-gohub-picker-grid-label]');
    var browseHint = this.picker.querySelector('[data-gohub-picker-browse-hint]');

    if (grid) grid.innerHTML = '';
    if (gridLabel) gridLabel.hidden = true;
    if (browseHint) browseHint.hidden = true;

    if (!value || !subSelect || !subWrap) return;

    var category = this.findCategory(value);
    if (!category) return;

    subSelect.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = this.picker.getAttribute('data-subcategory-placeholder') || 'Choose a subcategory';
    subSelect.appendChild(placeholder);

    if (category.children && category.children.length > 0) {
      subWrap.hidden = false;
      category.children.forEach(function (child) {
        var option = document.createElement('option');
        option.value = child.handle;
        option.textContent = child.title;
        subSelect.appendChild(option);
      });
      this.loadCategoryProducts(category);
      return;
    }

    subWrap.hidden = true;
    this.loadCategoryProducts(category);
  };

  ProductPicker.prototype.onSubcategoryChange = function () {
    var categorySelect = this.picker.querySelector('[data-gohub-picker-category]');
    var subSelect = this.picker.querySelector('[data-gohub-picker-subcategory]');
    if (!categorySelect || !subSelect) return;

    var subHandle = subSelect.value;
    if (subHandle) {
      this.loadCollectionProducts(subHandle);
      return;
    }

    var category = this.findCategory(categorySelect.value);
    this.loadCategoryProducts(category);
  };

  ProductPicker.prototype.fetchCollectionProducts = function (handle) {
    var url = apiUrl(this.picker, 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + COLLECTION_LIMIT);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('collection_' + res.status);
        return res.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      });
  };

  ProductPicker.prototype.renderGridProducts = function (products) {
    var grid = this.picker.querySelector('[data-gohub-picker-grid]');
    var gridLabel = this.picker.querySelector('[data-gohub-picker-grid-label]');
    var browseHint = this.picker.querySelector('[data-gohub-picker-browse-hint]');
    if (!grid) return;

    grid.innerHTML = '';
    if (gridLabel) gridLabel.hidden = false;
    if (browseHint) browseHint.hidden = true;

    if (!products.length) {
      if (browseHint) browseHint.hidden = false;
      if (gridLabel) gridLabel.hidden = true;
      return;
    }

    var self = this;
    products.forEach(function (product) {
      grid.appendChild(self.buildGridButton(product));
    });
  };

  ProductPicker.prototype.loadCategoryProducts = function (category) {
    if (!category) return;
    var self = this;

    if (category.handle) {
      this.fetchCollectionProducts(category.handle)
        .then(function (products) { self.renderGridProducts(products); })
        .catch(function (err) {
          console.warn('[gohub-product-picker] Collection load failed:', err && err.message);
          self.renderGridProducts([]);
        });
      return;
    }

    if (!category.children || !category.children.length) {
      this.renderGridProducts([]);
      return;
    }

    var handles = category.children.map(function (child) { return child.handle; }).filter(Boolean);
    if (!handles.length) {
      this.renderGridProducts([]);
      return;
    }

    Promise.all(handles.map(function (handle) {
      return self.fetchCollectionProducts(handle).catch(function () { return []; });
    })).then(function (lists) {
      var seen = {};
      var merged = [];
      lists.forEach(function (list) {
        list.forEach(function (product) {
          var key = String(product.id || product.handle || '');
          if (!key || seen[key]) return;
          seen[key] = true;
          merged.push(product);
        });
      });
      self.renderGridProducts(merged);
    });
  };

  ProductPicker.prototype.runSearch = function (query) {
    var resultsEl = this.picker.querySelector('[data-gohub-picker-results]');
    var hintEl = this.picker.querySelector('[data-gohub-picker-search-hint]');
    if (!resultsEl) return;

    resultsEl.innerHTML = '';
    resultsEl.hidden = true;
    if (hintEl) hintEl.hidden = true;

    if (query.length < 2) return;

    var url = apiUrl(this.picker, 'search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources%5Btype%5D=product'
      + '&resources%5Blimit%5D=' + SEARCH_LIMIT
      + '&resources%5Boptions%5D%5Bunavailable_products%5D=last'
      + '&resources%5Boptions%5D%5Bfields%5D=title,variants.sku,vendor,product_type');

    var self = this;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('search_' + res.status);
        return res.json();
      })
      .then(function (data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        if (!products.length) {
          if (hintEl) hintEl.hidden = false;
          return;
        }
        products.forEach(function (product) {
          resultsEl.appendChild(self.buildResultButton(product));
        });
        resultsEl.hidden = false;
      })
      .catch(function (err) {
        console.warn('[gohub-product-picker] Search failed:', err && err.message);
        if (hintEl) hintEl.hidden = false;
      });
  };

  ProductPicker.prototype.loadCollectionProducts = function (handle) {
    var self = this;
    this.fetchCollectionProducts(handle)
      .then(function (products) { self.renderGridProducts(products); })
      .catch(function (err) {
        console.warn('[gohub-product-picker] Collection load failed:', err && err.message);
        self.renderGridProducts([]);
      });
  };

  ProductPicker.prototype.buildResultButton = function (product) {
    var li = document.createElement('li');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gohub-product-picker__result';
    btn.innerHTML =
      '<img class="gohub-product-picker__thumb" src="' + esc(productImage(product)) + '" alt="" loading="lazy">' +
      '<span><p class="gohub-product-picker__item-title">' + esc(product.title) + '</p></span>';

    var self = this;
    btn.addEventListener('click', function () {
      self.selectFromHandle(product.handle, {
        id: product.id,
        title: product.title,
        image: productImage(product)
      });
    });

    li.appendChild(btn);
    return li;
  };

  ProductPicker.prototype.buildGridButton = function (product) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gohub-product-picker__grid-item';
    var imageSrc = productImage(product);
    var sku = product.variants && product.variants[0] ? product.variants[0].sku : '';
    btn.innerHTML =
      '<img class="gohub-product-picker__thumb" src="' + esc(imageSrc) + '" alt="" loading="lazy">' +
      '<span><p class="gohub-product-picker__item-title">' + esc(product.title) + '</p>' +
      (sku ? '<p class="gohub-product-picker__item-sku">' + esc(sku) + '</p>' : '') +
      '</span>';

    var self = this;
    btn.addEventListener('click', function () {
      self.selectProduct({
        id: product.id,
        handle: product.handle,
        title: product.title,
        image: imageSrc,
        variant_sku: sku,
        variant_id: product.variants && product.variants[0] ? product.variants[0].id : ''
      });
    });

    return btn;
  };

  ProductPicker.prototype.selectFromHandle = function (handle, partial) {
    if (!handle) return;
    var url = apiUrl(this.picker, 'products/' + encodeURIComponent(handle) + '.js');
    var self = this;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variant = (product.variants && product.variants[0]) || {};
        self.selectProduct({
          id: product.id || (partial && partial.id),
          handle: product.handle || handle,
          title: product.title || (partial && partial.title),
          image: productImage(product) || (partial && partial.image) || '',
          variant_sku: variant.sku || '',
          variant_id: variant.id || ''
        });
      })
      .catch(function () {
        self.selectProduct({
          id: partial && partial.id,
          handle: handle,
          title: partial && partial.title,
          image: partial && partial.image,
          variant_sku: '',
          variant_id: ''
        });
      });
  };

  ProductPicker.prototype.fetchInstructionsMeta = function (handle) {
    if (!handle) return Promise.resolve(null);
    var url = apiUrl(this.picker, 'products/' + encodeURIComponent(handle) + '?view=contact-meta');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('instructions_meta_' + res.status);
        return res.text();
      })
      .then(function (text) {
        return parseInstructionsMeta(text);
      })
      .catch(function (err) {
        console.warn('[gohub-product-picker] Instructions meta failed:', err && err.message);
        return null;
      });
  };

  ProductPicker.prototype.renderInstructionsPrompt = function (product, meta) {
    var promptWrap = this.picker.querySelector('[data-gohub-picker-instructions]');
    var promptText = this.picker.querySelector('[data-gohub-picker-instructions-text]');
    if (!promptWrap || !promptText) return Promise.resolve();

    var self = this;
    var hasInstructions = meta && meta.has_instructions === true;
    var ref = meta && meta.instructions_ref ? String(meta.instructions_ref).trim() : '';
    if (!hasInstructions || !ref) {
      promptWrap.hidden = true;
      promptText.innerHTML = '';
      if (product) product.instructions_url = '';
      return Promise.resolve();
    }

    return fetchAssetsInstructionUrl(this.picker, ref).then(function (url) {
      if (!url) {
        promptWrap.hidden = true;
        promptText.innerHTML = '';
        if (product) product.instructions_url = '';
        return;
      }

      var before = self.picker.getAttribute('data-instructions-before') || 'We have an ';
      var linkLabel = self.picker.getAttribute('data-instructions-link') || 'instructions document';
      var middle = self.picker.getAttribute('data-instructions-middle') || ' for this product — ';
      var linkLabel2 = self.picker.getAttribute('data-instructions-link-2') || 'click here';
      var after = self.picker.getAttribute('data-instructions-after') || '';

      var linkHtml = function (label) {
        return '<a class="gohub-product-picker__instructions-link" href="' + esc(url) + '" target="_blank" rel="noopener noreferrer">' + esc(label) + '</a>';
      };

      promptText.innerHTML =
        esc(before) +
        linkHtml(linkLabel) +
        esc(middle) +
        linkHtml(linkLabel2) +
        esc(after);

      promptWrap.hidden = false;
      if (product) product.instructions_url = url;
    });
  };

  ProductPicker.prototype.getEmbeddedInstructionsMeta = function (product) {
    if (!this.root || !product || !product.handle) return null;
    var node = this.root.querySelector('[data-gohub-page-instructions-meta]');
    if (!node) return null;
    var pageHandle = this.root.getAttribute('data-gohub-product-handle') || '';
    if (pageHandle && product.handle !== pageHandle) return null;
    return parseInstructionsMeta(node.textContent);
  };

  ProductPicker.prototype.applyInstructionsMeta = function (product) {
    var self = this;
    if (!product || !product.handle) {
      return this.renderInstructionsPrompt(product, null);
    }

    var embedded = this.getEmbeddedInstructionsMeta(product);
    if (embedded) {
      if (!this.selected || this.selected.handle !== product.handle) return Promise.resolve();
      return this.renderInstructionsPrompt(this.selected, embedded);
    }

    var requestHandle = product.handle;
    return this.fetchInstructionsMeta(requestHandle).then(function (meta) {
      if (!self.selected || self.selected.handle !== requestHandle) return;
      return self.renderInstructionsPrompt(self.selected, meta);
    });
  };

  ProductPicker.prototype.selectProduct = function (product, silent) {
    this.selected = product;
    this.setError(false);
    this.syncRootAttributes(product);

    var selectedWrap = this.picker.querySelector('[data-gohub-picker-selected]');
    var panel = this.picker.querySelector('[data-gohub-picker-panel]');
    var titleEl = this.picker.querySelector('[data-gohub-picker-selected-title]');
    var skuEl = this.picker.querySelector('[data-gohub-picker-selected-sku]');
    var imageEl = this.picker.querySelector('[data-gohub-picker-selected-image]');

    if (titleEl) titleEl.textContent = product.title || '';
    if (skuEl) {
      skuEl.textContent = product.variant_sku ? ('SKU: ' + product.variant_sku) : '';
      skuEl.hidden = !product.variant_sku;
    }
    if (imageEl) {
      imageEl.src = product.image || '';
      imageEl.alt = product.title || '';
      imageEl.hidden = !product.image;
    }
    if (selectedWrap) selectedWrap.hidden = false;
    if (panel) panel.hidden = true;
    this.picker.setAttribute('data-gohub-picker-has-selection', 'true');

    this.applyInstructionsMeta(product);
  };

  ProductPicker.prototype.clearSelection = function (showPanel) {
    if (showPanel === undefined) showPanel = true;
    if (this.pageProductMode) {
      this.userClearedPageProduct = true;
    }
    this.selected = null;
    this.syncRootAttributes(null);
    this.renderInstructionsPrompt(null, null);

    var selectedWrap = this.picker.querySelector('[data-gohub-picker-selected]');
    var panel = this.picker.querySelector('[data-gohub-picker-panel]');
    var searchInput = this.picker.querySelector('[data-gohub-picker-search]');
    var resultsEl = this.picker.querySelector('[data-gohub-picker-results]');

    if (selectedWrap) selectedWrap.hidden = true;
    if (panel && showPanel) panel.hidden = false;
    this.picker.removeAttribute('data-gohub-picker-has-selection');
    if (searchInput) searchInput.value = '';
    if (resultsEl) {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
    }
  };

  ProductPicker.prototype.syncRootAttributes = function (product) {
    if (!this.root) return;
    var map = {
      'data-gohub-product-id': product && product.id ? String(product.id) : '',
      'data-gohub-product-handle': product && product.handle ? product.handle : '',
      'data-gohub-product-title': product && product.title ? product.title : '',
      'data-gohub-variant-sku': product && product.variant_sku ? product.variant_sku : '',
      'data-gohub-variant-id': product && product.variant_id ? String(product.variant_id) : ''
    };
    Object.keys(map).forEach(function (key) {
      if (map[key]) {
        this.root.setAttribute(key, map[key]);
      } else {
        this.root.removeAttribute(key);
      }
    }, this);
  };

  ProductPicker.prototype.validate = function () {
    if (!this.categorySelect || this.categorySelect.value !== PRODUCT_CATEGORY) {
      this.setError(false);
      return true;
    }
    if (this.selected && this.selected.title) {
      this.setError(false);
      return true;
    }
    if (this.pageProductMode && !this.userClearedPageProduct) {
      this.prefillFromPageProduct();
      if (this.selected && this.selected.title) {
        this.setError(false);
        return true;
      }
    }
    this.setError(true);
    this.picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    return false;
  };

  ProductPicker.prototype.setError = function (show) {
    var errorEl = this.picker.querySelector('[data-gohub-picker-error]');
    this.picker.classList.toggle('is-invalid', !!show);
    if (errorEl) errorEl.hidden = !show;
  };

  ProductPicker.prototype.getSelected = function () {
    return this.selected;
  };

  function initPickers() {
    document.querySelectorAll('[data-gohub-product-picker]').forEach(function (pickerEl) {
      if (pickerEl.__gohubPickerInit) return;
      pickerEl.__gohubPickerInit = true;
      var picker = new ProductPicker(pickerEl);
      pickerEl.__gohubPicker = picker;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickers);
  } else {
    initPickers();
  }

  window.GohubContactProductPicker = {
    init: initPickers,
    getForRoot: function (root) {
      if (!root) return null;
      var pickerEl = root.parentElement && root.parentElement.querySelector('[data-gohub-product-picker]');
      if (!pickerEl && root.nextElementSibling) {
        pickerEl = root.querySelector('[data-gohub-product-picker]') || root.parentElement.querySelector('[data-gohub-product-picker]');
      }
      var node = root.querySelector('[data-gohub-product-picker]');
      return node && node.__gohubPicker ? node.__gohubPicker : null;
    }
  };
})();
